import { render } from "./TrainDateHistoryDetailView.vue?vue&type=template&id=4713725f&scoped=true"
import script from "./TrainDateHistoryDetailView.vue?vue&type=script&lang=js"
export * from "./TrainDateHistoryDetailView.vue?vue&type=script&lang=js"

import "./TrainDateHistoryDetailView.vue?vue&type=style&index=0&id=4713725f&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4713725f"]])

export default __exports__